import { makeAutoObservable } from "mobx"
import storeFeelGreat from "./FeelGreat/StoreFeelGreat"

class StoreComplexPassword {

    DESCRIPTION_KEYS = [
        'Be_minimun_8_characters',
        'include_least_one_lowercase_letter',
        'include_least_one_uppercase_letter',
        'include_least_one_number',
        'include_least_one_special_character',
    ]

    errorComplexPassword = []

    setErrorComplexPassword = (errors) => {
        this.errorComplexPassword = errors
    }

    getErrorComplexPassword = () => {
        if(storeFeelGreat.passwordSettings.isUseComplexPassword === false) return []
        return this.errorComplexPassword
    }

    checkPasswordStrength = (password) => {

        this.setErrorComplexPassword([])
        
        const errors = []

        const criteria = [
            {
                regex: /[a-z]/,
                error: 'error_password_least_one_lowercase',
            },
            {
                regex: /[A-Z]/,
                error: 'error_password_least_one_uppercase',
            },
            {
                regex: /[0-9]/,
                error: 'error_password_least_one_number',
            },
            {
                regex: /[!@#$%^&*(),.?":{}|<>+-/_=]/,
                error: 'error_password_least_one_special',
            },
            {
                regex: /^[A-Za-z0-9!@#$%^&*()\-+=\[\]{}|\\:;'"<>,.?/]+$/,
                error: 'error_password_format'
            },
            {
                regex: /^\S*$/,
                error: 'error_password_must_not_contain_spaces'
            }
        ]

        criteria.forEach(({ regex, error }) => {
            if (!regex.test(password)) {
                errors.push(error)
            } 
        })

        if (password.length < 8) {
            errors.push('error_password_must_least_8_char')
        }

        this.setErrorComplexPassword(errors)
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const storeComplexPassword = new StoreComplexPassword()
export default storeComplexPassword